var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scheme-container"},[_c('van-button',{attrs:{"round":"","type":"primary"},on:{"click":_vm.handleClick}},[_vm._v(" 打开微信 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }